// extracted by mini-css-extract-plugin
export default {"container":"CookieBanner_container__bdjTX","title":"CookieBanner_title__HW+cd","text":"CookieBanner_text__n7xYP","buttons":"CookieBanner_buttons__kLlKS"};